import { Link, NavLink } from "react-router-dom";
import { DropDownIcon, HamburgerIcon, navLinks } from "./constants";
import { useState } from "react";

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <header className="bg-white z-[10] sticky top-0 md:border-b md:border-b-[#B6E4FF]">
      {!toggleMenu && (
        // Desktop Nav
        <nav className="container w-full px-3 py-[24px] flex justify-between items-center ">
          <Logo />

          <div className="hidden md:flex gap-7 items-center">
            {navLinks.map((link) => (
              <NavItem key={link.label} link={link} />
            ))}
          </div>

          <GetStarted />

          <Hamburger setToggleMenu={setToggleMenu} toggleMenu={toggleMenu} />
        </nav>
      )}

      {/* Mobile Nav */}
      <div
        className={`fixed top-0 left-0 h-screen w-[280px] sm:w-[300px] bg-white shadow-xl z-[150] transform transition-transform duration-500 ease-in-out ${
          toggleMenu ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="w-full px-3 py-[24px] flex justify-between items-center ">
          <Logo />
          <Hamburger setToggleMenu={setToggleMenu} toggleMenu={toggleMenu} />
        </div>

        <div className="flex flex-col gap-7 px-3">
          {navLinks.map((link) => (
            <NavItem key={link.label} link={link} />
          ))}

          <GetStarted isMobile />
        </div>
      </div>
    </header>
  );
};

export default Navbar;

const Logo = () => (
  <Link to="/">
    <img
      src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1755225926/powerdbyai/logo_v6xcrn.svg"
      alt="Logo"
    />
  </Link>
);

const NavItem = ({ link }) =>
  link?.href ? (
    <NavLink
      to={link.href}
      className={({ isActive }) =>
        `hover:text-primary transition-colors px-1 ${
          isActive ? "border-b-[1.5px] border-b-primary_alt" : ""
        }`
      }
    >
      {link.label}
    </NavLink>
  ) : (
    <div className="relative group">
      <button
        type="button"
        className="flex gap-1 items-center focus:outline-none hover:text-primary transition-colors w-full justify-between md:justify-start"
      >
        <p className="px-1">{link.label}</p>
        <DropDownIcon />
      </button>
      <div className="hidden absolute md:top-6 bg-white group-hover:flex flex-col gap-1 w-[253px] rounded-lg shadow-lg z-[100] px-2 py-4">
        {link.links.map((l) => (
          <NavLink
            key={l.label}
            to={l.link}
            className={({ isActive }) =>
              `hover:text-primary transition-colors px-3 text-sm py-2 text-[#222] font-medium ${
                isActive ? "border-b-[1.5px] border-b-primary_alt" : ""
              }`
            }
          >
            {l.label}
          </NavLink>
        ))}
      </div>
    </div>
  );

const GetStarted = ({ isMobile = false }) => (
  <Link
    to="/signup"
    reloadDocument
    className={`${
      isMobile ? "" : "hidden md:inline-block"
    } rounded-lg text-center bg-primary_alt border border-[#B6E4FF] py-2.5 px-4 text-white hover:text-white/80`}
  >
    Get Started
  </Link>
);

const Hamburger = ({ setToggleMenu, toggleMenu }) => (
  <button
    type="button"
    className="md:hidden p-1.5 cursor-pointer"
    onClick={() => setToggleMenu((prev) => !prev)}
    title={toggleMenu ? "close" : "menu"}
  >
    <HamburgerIcon isOpen={toggleMenu} />
  </button>
);
